module.exports = __webpack_public_path__ + "img/gridModeOn.0f1db4d4.svg";